/**
 * Mock claims data in API response format.
 * Used when REACT_APP_USE_MOCK_CLAIMS=true or when the real API fails (e.g. backend unavailable).
 *
 * To disable: remove or set REACT_APP_USE_MOCK_CLAIMS=false in .env
 */

export const claimsApiMockResponse = {
  claims: [
    {
      claim_id: 'mock-claim-1',
      patient_id: 'mock-patient-1',
      date_time_created_at: '2024-12-01T10:00:00Z',
      date_time_updated_at: '2024-12-15T14:30:00Z',
      public_id: 'CLM-001',
      claim_type: 'Claims',
      claim_amount: '500.00',
      appointment_id: null,
      treatment_plan_id: 'tp-1',
      provider_entity_type: 'Individual',
      notes: '',
      patient: {
        patient_id: 'mock-patient-1',
        first_name: 'John',
        last_name: 'Doe',
        date_of_birth: '1985-03-15',
        gender: 'Male',
      },
      provider: {
        provider_id: 'prov-1',
        first_name: 'Jane',
        last_name: 'Smith',
        tax_id_number: '12-3456789',
      },
      insuranceplan: {
        subscriber: {
          subscriber_id: 'sub-001',
          first_name: 'John',
          last_name: 'Doe',
          date_of_birth: '1985-03-15',
        },
        patient: { member_id: 'M001' },
        carrier: {
          carrier_id: 'carrier-1',
          carrier_name: 'Delta Dental',
          payer_id: '12345',
        },
        group_name: 'Group A',
        group_no: 'GRP001',
        insurance_plan_id: 'plan-1',
      },
      claimitems: [
        {
          claim_item_id: 'item-1',
          proc_log_id: null,
          item_id: 'item-1',
          amount: '150.00',
          notes: '',
          insurance_plan_id: 'plan-1',
          clinic_fee: '150.00',
          allowed_amount: 120,
          write_off: 30,
          estimated_insurance_pay: 96,
          estimated_patient_resp: 24,
          treatment_plan_item: {
            procedure_settings: {
              procedure: {
                procedure_id: 'proc-1',
                description: 'Teeth Cleaning',
                procedure_code: 'D1110',
              },
            },
            surface: 'M',
            treatment_plan_phase: {
              phase_name: 'Phase 1',
              scheduled_date: '2024-11-29',
            },
          },
          claimitemattachments: [
            {
              claim_item_attachment_id: 'att-1',
              type: 'RB',
              date_time_created_at: '2024-11-30T09:00:00Z',
              file: {
                original_name: 'xray.jpg',
                mime_type: 'image/jpeg',
                file_size: 102400,
                file_path: '/files/xray.jpg',
              },
            },
          ],
        },
      ],
      claimattachments: [
        {
          claim_attachment_id: 'ca-1',
          type: 'EB',
          date_time_created_at: '2024-12-01T10:00:00Z',
          file: {
            original_name: 'eob.pdf',
            mime_type: 'application/pdf',
            file_size: 51200,
            file_path: '/files/eob.pdf',
          },
        },
      ],
      claimstatus: [
        {
          claim_status_paid_amount: '96.00',
          claimstatuscodes: [{ code: 'F1' }],
          claimstatusitems: [],
        },
      ],
    },
    {
      claim_id: 'mock-claim-2',
      patient_id: 'mock-patient-2',
      date_time_created_at: '2024-12-05T09:00:00Z',
      date_time_updated_at: '2024-12-18T11:00:00Z',
      public_id: 'CLM-002',
      claim_type: 'Pre-Authorization',
      claim_amount: '800.00',
      appointment_id: null,
      treatment_plan_id: 'tp-2',
      provider_entity_type: 'Individual',
      notes: 'Pre-auth for root canal',
      patient: {
        patient_id: 'mock-patient-2',
        first_name: 'Jane',
        last_name: 'Smith',
        date_of_birth: '1990-07-22',
        gender: 'Female',
      },
      provider: {
        provider_id: 'prov-1',
        first_name: 'Jane',
        last_name: 'Smith',
        tax_id_number: '12-3456789',
      },
      insuranceplan: {
        subscriber: {
          subscriber_id: 'sub-002',
          first_name: 'Jane',
          last_name: 'Smith',
          date_of_birth: '1990-07-22',
        },
        patient: { member_id: 'M002' },
        carrier: {
          carrier_id: 'carrier-2',
          carrier_name: 'Blue Cross Dental',
          payer_id: '67890',
        },
        group_name: 'Group B',
        group_no: 'GRP002',
        insurance_plan_id: 'plan-2',
      },
      claimitems: [
        {
          claim_item_id: 'item-2',
          proc_log_id: null,
          item_id: 'item-2',
          amount: '800.00',
          notes: '',
          insurance_plan_id: 'plan-2',
          clinic_fee: '800.00',
          allowed_amount: 600,
          write_off: 200,
          estimated_insurance_pay: 480,
          estimated_patient_resp: 120,
          treatment_plan_item: {
            procedure_settings: {
              procedure: {
                procedure_id: 'proc-2',
                description: 'Root Canal',
                procedure_code: 'D3310',
              },
            },
            surface: '',
            treatment_plan_phase: {
              phase_name: 'Phase 1',
              scheduled_date: '2024-12-10',
            },
          },
          claimitemattachments: [],
        },
      ],
      claimattachments: [],
      claimstatus: [
        {
          claim_status_paid_amount: '',
          claimstatuscodes: [{ code: 'F2' }], // F2 = Rejected (enables Edit action in Action column)
          claimstatusitems: [],
        },
      ],
    },
    {
      claim_id: 'mock-claim-3',
      patient_id: 'mock-patient-3',
      date_time_created_at: '2024-12-10T08:00:00Z',
      date_time_updated_at: '2024-12-20T16:00:00Z',
      public_id: 'CLM-003',
      claim_type: 'Claims',
      claim_amount: '300.00',
      appointment_id: null,
      treatment_plan_id: 'tp-3',
      provider_entity_type: 'Individual',
      notes: '',
      patient: {
        patient_id: 'mock-patient-3',
        first_name: 'Mark',
        last_name: 'Johnson',
        date_of_birth: '1978-11-08',
        gender: 'Male',
      },
      provider: {
        provider_id: 'prov-1',
        first_name: 'Jane',
        last_name: 'Smith',
        tax_id_number: '12-3456789',
      },
      insuranceplan: {
        subscriber: {
          subscriber_id: 'sub-003',
          first_name: 'Sarah',
          last_name: 'Johnson',
          date_of_birth: '1980-05-12',
        },
        patient: { member_id: 'M003' },
        carrier: {
          carrier_id: 'carrier-1',
          carrier_name: 'Delta Dental',
          payer_id: '12345',
        },
        group_name: 'Group A',
        group_no: 'GRP001',
        insurance_plan_id: 'plan-1',
      },
      claimitems: [
        {
          claim_item_id: 'item-3',
          proc_log_id: null,
          item_id: 'item-3',
          amount: '300.00',
          notes: '',
          insurance_plan_id: 'plan-1',
          clinic_fee: '300.00',
          allowed_amount: 250,
          write_off: 50,
          estimated_insurance_pay: 200,
          estimated_patient_resp: 50,
          treatment_plan_item: {
            procedure_settings: {
              procedure: {
                procedure_id: 'proc-3',
                description: 'Extraction',
                procedure_code: 'D7240',
              },
            },
            surface: '',
            treatment_plan_phase: {
              phase_name: 'Phase 1',
              scheduled_date: '2024-12-08',
            },
          },
          claimitemattachments: [],
        },
      ],
      claimattachments: [],
      claimstatus: [
        {
          claim_status_paid_amount: '',
          claimstatuscodes: [{ code: 'F2' }], // F2 = Rejected (enables Edit action in Action column)
          claimstatusitems: [],
        },
      ],
    },
  ],
}
